import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRouting } from './dashboard.routing.module';
import { DashboardComponent } from './theme/pages/dashboard/dashboard.component';
import { ThemeModule } from '../../../../theme/theme.module';
import { PrincipalComponent } from './theme/sections/principal/principal.component';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { XsHeaderDashboardComponent } from './theme/sections/xs-header-dashboard/xs-header-dashboard.component';
import { XsInvestmentsDashboardComponent } from './theme/sections/xs-investments-dashboard/xs-investments-dashboard.component';
import { TableBalanceComponent } from './theme/sections/table-balance/table-balance.component';
import { ModalWellcomeComponent } from './theme/sections/modal-wellcome/modal-wellcome.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { XsTableBalanceComponent } from './theme/sections/xs-table-balance/xs-table-balance.component';
import { ModalCucsComponent } from './theme/sections/modal-cucs/modal-cucs.component';
import { MatSelectModule } from '@angular/material/select';
import { HeaderSectionComponent } from './theme/sections/header-section/header-section.component';
import { NoMovementsComponent } from './theme/sections/no-movements/no-movements.component';
import { CurrencyDecimalPipe } from 'src/app/theme/components/currency-decimal.pipe';
import { XsTableTooltipComponent } from './theme/sections/xs-table-tooltip/xs-table-tooltip.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ModalSurveyComponent } from './theme/sections/modal-survey/modal-survey.component';
import { ModalActualizarDatosComponent } from './theme/sections/modal-actualizar-datos/modal-actualizar-datos.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
    imports: [
        CommonModule,
        DashboardRouting,
        MatIconModule,
        ThemeModule,
        ReactiveFormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatButtonModule,
        MatDialogModule,
        MatSelectModule,
        ChartsModule,
        NgxSkeletonLoaderModule,
        MatCheckboxModule,
        NgxMaskModule.forRoot(),
    ],
    declarations: [
        DashboardComponent,
        PrincipalComponent,
        HeaderSectionComponent,
        XsHeaderDashboardComponent,
        XsInvestmentsDashboardComponent,
        TableBalanceComponent,
        ModalWellcomeComponent,
        XsTableBalanceComponent,
        ModalCucsComponent,
        NoMovementsComponent,
        CurrencyDecimalPipe,
        XsTableTooltipComponent,
        ModalSurveyComponent,
        ModalActualizarDatosComponent
    ],
    providers: [ThemeService],
    exports: [DashboardComponent]
})
export class DashboardModule { }
